import { useRoute } from '#imports'
import { ref, watch } from 'vue'

import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

import { useUrlParams } from '~/scopes/product/composables/useUrlParams'

import { useRequests } from './useRequests'

function useFetchRating() {
  const route = useRoute()
  const requests = useRequests()
  const { productId } = useUrlParams()

  if (!requests || !('getRating' in requests))
    return { data: ref(), error: ref(), pending: ref(false) }

  return useHttpFetch(requests.getRating, {
    pathParams: {
      uuid: route.params?.uuid ? route.params.uuid : productId,
    },
  })
}

export function useGlobalRating() {
  const route = useRoute()

  const logger = useLogger()

  const { data: ratesResponse, error, pending } = useFetchRating()

  watch(
    error,
    () => {
      if (error.value instanceof Error) {
        logger.error(`[REVIEWS][${route.name?.toString()}]`, {
          error: error.value,
          owners: ['bot-squad-content-front'],
        })
      }
    },
    { immediate: true },
  )

  return {
    pendingRatesResponse: pending,
    ratesResponse,
  }
}
